import React, { useState } from 'react';

const AntilogarithmTable = () => {
  const [numberFrom, setNumberFrom] = useState(0.00);
  const [numberTo, setNumberTo] = useState(0.00);

  const [antilogTable, setAntilogTable] = useState([]);

  const calculateAntilogTable = () => {
    const table = [];
    const step = 0.01;
    const iterations = Math.ceil((numberTo - numberFrom) / step);
  
    for (let i = 0; i <= iterations; i++) {
      const baseNumber = numberFrom + i * step;
      const antilogValue = (10 ** baseNumber).toFixed(5);
      const meanDifference = ((10 ** (baseNumber + 0.01)) - antilogValue).toFixed(5);
      table.push({ baseNumber, antilogValue, meanDifference });
    }
  
    setAntilogTable(table);
  };

  return (
    <div>
      <h2 className='mb-2 text-yellow-200'>Antilogarithm Table Generator</h2>
      <p>From (0.00 - 0.99): </p>
      <input
        type="number"
        id="numberInputFrom"
        min="0.00"
        max="0.99"
        step="0.01"
        value={numberFrom}
        onChange={(e) => setNumberFrom(parseFloat(e.target.value))}
      />
      <p>To (0.00 - 0.99): </p>
      <input
        type="number"
        id="numberInputTo"
        min="0.00"
        max="0.99"
        step="0.01"
        value={numberTo}
        onChange={(e) => setNumberTo(parseFloat(e.target.value))}
      />
      <button className="mt-4 mb-4" onClick={calculateAntilogTable}>Generate Antilogarithm Table From {numberFrom} to {numberTo}</button>

      {antilogTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Base Number</th>
              <th>Antilog Value</th>
              <th>Mean Difference</th>
            </tr>
          </thead>
          <tbody>
            {antilogTable.map((row, index) => (
              <tr key={index}>
                <td>{row.baseNumber.toFixed(2)}</td>
                <td>{row.antilogValue}</td>
                <td>{row.meanDifference}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AntilogarithmTable;
